import React, { forwardRef } from "react";
import {
  BRAND,
  BRAND_DARK,
  TEXT_PRIMARY,
  WHITE
} from "@streeteasy/design-system/colors";
import { bool, node, oneOf, string } from "prop-types";

import { CapsLink, TextActionBase } from "./styled";
import textLinkTypography from "./textLinkTypography";

/**
 * @deprecated use the TextAction component instead
 */

const TextLink = forwardRef(
  (
    { children, color, href, typography, underlined, ...passThroughProps },
    ref
  ) => {
    const Link =
      typography === textLinkTypography.CAPS ? CapsLink : TextActionBase;

    return (
      <Link
        ref={ref}
        color={color}
        href={href}
        typography={typography}
        underlined={underlined}
        {...passThroughProps}
      >
        {children}
      </Link>
    );
  }
);

TextLink.propTypes = {
  children: node.isRequired,
  color: oneOf([BRAND, BRAND_DARK, TEXT_PRIMARY, WHITE]),
  href: string.isRequired,
  /**
   * Determines the typography styles inherited by TextLink.
   *
   * Values for the typography prop are imported from the textLinkTypography module.
   *
   * ```
   * import TextLink from "./TextLink";
   * ```
   * ```
   * import textLinkTypography from "./textLinkTypography";
   *```
   *```
   * export const MyTextLink = () => (
   *   <TextLink href="/path/to/similar/listings" typography={textLinkTypography.CAPS}>
   *     See Similar Listings
   *   </TextLink>
   * );
   * ```
   * */
  typography: oneOf(Object.values(textLinkTypography)),
  underlined: bool
};

TextLink.defaultProps = {
  color: BRAND,
  typography: textLinkTypography.BODY,
  underlined: true
};

TextLink.displayName = "TextLink";

export default TextLink;
